import {w3cwebsocket as W3CWebSocket} from "websocket";
import Results from '../../components/results/index.js';

var React = require('react');
var update = require('immutability-helper');

const client = new W3CWebSocket(process.env.REACT_APP_WEBSOCKET_URL);

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: 'disconnected',
            search: false,
            keyword: '',
            initTimestamp: '',
            collectedTweets: [],
            binnedTweets: [{numTweets: 0, posTweets: 0, negTweets: 0, neutTweets: 0, timeBin: 5}],
            totalTweets: {total: 0, posTotal: 0, negTotal: 0, neutTotal: 0},
            sentiment: 'Neutral'
        };

        this.emit = this.emit.bind(this);
        this.initTimestamp = this.initTimestamp.bind(this);

    }

    componentDidMount() {
        var self = this;
        client.onopen = () => {
            this.emit("subscribe", "twitter_stream.twitter_stream")
            this.connect.bind(this)
        };
        client.onclose = () => {
            this.emit("unsubscribe", "twitter_stream.twitter_stream")
            this.disconnect.bind(this)
        };
        client.onmessage = (message) => {
            var data = JSON.parse(message.data);
            if (data.event === 'subscribe') {
                return;
            }
            data = JSON.parse(message.data);
            self.addTweet(data.data.tweet.tweet);
        };
    }

    componentWillUnmount() {
        this.emit("unsubscribe", "twitter_stream.twitter_stream")
    }

    emit(eventName, subscription) {
        client.send(JSON.stringify({
            event: eventName,
            subscription: subscription,
        }))

        // Reset Dashboard on New Search
        this.setState({
            collectedTweets: [],
            binnedTweets: [{
                numTweets: 0, posTweets: 0,
                negTweets: 0, neutTweets: 0, timeBin: 5
            }],
            totalTweets: {
                total: 0, posTotal: 0,
                negTotal: 0, neutTotal: 0
            }
        });
    }

    connect() {
        this.setState({status: 'connected'});
        // console.log('Connected on socket: %s', this.socket.id);
    }

    disconnect() {
        this.setState({status: 'disconnected'});
        // console.log('Disconnected: %s', this.socket.id);
    }

    initTimestamp(timestamp) {
        this.setState({initTimestamp: timestamp.initTimestamp});
        this.setState({search: true});
    }

    addTweet(tweet) {
        var tweets = this.state.collectedTweets;
        var newTweets = update(tweets, {$unshift: [tweet]});

        this.setState({collectedTweets: newTweets});
        this.binTweets(tweet.timestamp_ms, tweet.sentiment);
        this.countTweets(tweet.sentiment);
        this.overallSentiment();
    }

    countTweets(sentiment) {
        var totalTweets = this.state.totalTweets;
        var newTotal = totalTweets;

        if (sentiment === "positive") {
            totalTweets.posTotal++;
            totalTweets.total++;
            this.setState({totalTweets: newTotal});

        } else if (sentiment === "negative") {
            totalTweets.negTotal++;
            totalTweets.total++;
            this.setState({totalTweets: newTotal});
        } else {
            totalTweets.neutTotal++;
            totalTweets.total++;
            this.setState({totalTweets: newTotal});
        }
    }

    overallSentiment() {
        var totalTweets = this.state.totalTweets.posTotal + this.state.totalTweets.negTotal;
        var posTweets = this.state.totalTweets.posTotal
        var sentiment = posTweets / totalTweets;

        if (sentiment < 0.5) {
            this.setState({sentiment: 'Negative'});
        } else if (sentiment > 0.5) {
            this.setState({sentiment: 'Positive'});
        } else {
            this.setState({sentiment: 'Neutral'});
        }
    }

    binTweets(tweetTimestamp, sentiment) {
        var initTimestamp = this.state.initTimestamp;
        var timeDiff = (tweetTimestamp - initTimestamp) / 1000;

        var binnedTweets = this.state.binnedTweets;
        var newBinnedTweets = binnedTweets;

        var binIndex = binnedTweets.length - 1;
        var currentBin = binnedTweets[binIndex].timeBin;

        if (timeDiff < currentBin) {
            newBinnedTweets[binIndex].numTweets++;

            if (sentiment === "positive") {
                newBinnedTweets[binIndex].posTweets++;
                this.setState({binnedTweets: newBinnedTweets});

            } else if (sentiment === "negative") {
                newBinnedTweets[binIndex].negTweets++;
                this.setState({binnedTweets: newBinnedTweets});
            } else {
                newBinnedTweets[binIndex].neutTweets++;
                this.setState({binnedTweets: newBinnedTweets});
            }
        } else {
            if (sentiment === "positive") {
                newBinnedTweets.push({
                    numTweets: 1,
                    posTweets: 1,
                    negTweets: 0,
                    neutTweets: 0,
                    timeBin: currentBin += 5
                });
                this.setState({binnedTweets: newBinnedTweets});
            } else if (sentiment === "negative") {
                newBinnedTweets.push({
                    numTweets: 1,
                    posTweets: 0,
                    negTweets: 1,
                    neutTweets: 0,
                    timeBin: currentBin += 5
                });
                this.setState({binnedTweets: newBinnedTweets});
            } else {
                newBinnedTweets.push({
                    numTweets: 1,
                    posTweets: 0,
                    negTweets: 0,
                    neutTweets: 1,
                    timeBin: currentBin += 5
                });
                this.setState({binnedTweets: newBinnedTweets});
            }
        }
    }

    render() {
        return (
            <div>
                <Results
                    collectedTweets={this.state.collectedTweets}
                    binnedTweets={this.state.binnedTweets}
                    totalTweets={this.state.totalTweets}
                    sentiment={this.state.sentiment}
                />
            </div>
        );
    }
}


